import React, { useState } from 'react';

const weekDayLabels = [
  { label: 'Sunday', value: 'SU' },
  { label: 'Monday', value: 'MO' },
  { label: 'Tuesday', value: 'TU' },
  { label: 'Wednesday', value: 'WE' },
  { label: 'Thursday', value: 'TH' },
  { label: 'Friday', value: 'FR' },
  { label: 'Saturday', value: 'SA' },
];

export default function RecurrenceSelector({ selectedRecurrence, onChange, initialValue }) {
  const [interval, setInterval] = useState(initialValue?.interval || 1);
  const [weekDays, setWeekDays] = useState(initialValue?.weekDays || []);
  const [monthlyDate, setMonthlyDate] = useState(initialValue?.dayOfMonth || null);
  const [endDate, setEndDate] = useState(initialValue?.endDate || '');

  const toggleWeekDay = (value) => {
    setWeekDays((prev) =>
      prev.includes(value)
        ? prev.filter((d) => d !== value)
        : [...prev, value]
    );
  };

  const renderOptions = () => {
    if (selectedRecurrence === "None") return null;

    return (
      <div className="flex flex-col gap-4 mt-4">
        <div className="d-flex flex-row justify-content-between mb-1">

            <div>
            <label className="font-bold">Recurrence Interval</label>
            <input
                type="number"
                min={1}
                value={interval}
                onChange={(e) => setInterval(parseInt(e.target.value))}
                className="form-input"
            />
            </div>

            <div>
            <label className="font-bold">End Date</label>
            <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="form-input"
            />
            </div>
        </div>
        

        {(selectedRecurrence === 'WEEKLY') && (
          <div>
            <label className="font-bold">Select Days of the Week</label>
            <div className="flex flex-wrap gap-2 mt-1">
              {weekDayLabels.map((day) => (
                <label key={day.value} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={weekDays.includes(day.value)}
                    onChange={() => toggleWeekDay(day.value)}
                  />
                  {day.label}
                </label>
              ))}
            </div>
          </div>
        )}

        {(selectedRecurrence === 'MONTHLY') && (
          <div>
            <label className="font-semibold">Day of Month</label>
            <input
              type="number"
              min={1}
              max={31}
              value={monthlyDate ?? ''}
              onChange={(e) => setMonthlyDate(parseInt(e.target.value))}
              className="form-input"
            />
          </div>
        )}

        
      </div>
    );
  };

  React.useEffect(() => {
    if (selectedRecurrence === "None") {
      onChange(null);
    } else {
      onChange({
        frequency: selectedRecurrence,
        interval,
        endDate: endDate || null,
        weekDays,
        dateOfMonth: monthlyDate,
      });
    }
  }, [selectedRecurrence, interval, endDate, weekDays, monthlyDate]);

  return (
    <div className="recurrence-selector">
      {renderOptions()}
    </div>
  );
}
